import React from 'react';
import { Container, Step, IconWrap, Description } from './PlanWidget.styled';

/**
 * PlanWidget - Step list with running/done/pending states.
 */
const PlanWidget = ({ planSteps = [] }) => {
  if (!planSteps.length) return null;

  const renderIcon = (status) => {
    if (status === 'running') return '●';
    if (status === 'done' || status === 'completed') return '✓';
    return '○';
  };

  return (
    <Container>
      {planSteps.map((s) => (
        <Step key={s.id ?? s.description}>
          <IconWrap $status={s.status ?? 'pending'} aria-hidden>
            {renderIcon(s.status)}
          </IconWrap>
          <Description $status={s.status ?? 'pending'}>
            {s.description ?? s.label ?? 'Step'}
          </Description>
        </Step>
      ))}
    </Container>
  );
};

export default PlanWidget;
